import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CUSTOMER_PORTAL_CONSTANT } from 'src/app/constant/constant';
import { Product } from 'src/app/shared/classes/product';
import { BrandSlider, HomeSlider, MultiProductSlider, PurchasedItemsSlider } from 'src/app/shared/data/slider';
import { GlobalService } from 'src/app/shared/services/global.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { CommonUtil } from 'src/app/shared/util/common-util';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  public themeLogo: String = 'assets/images/icon/logo-12.png'; // Change Logo
  public products: Product[] = [];
  public categories: any[];
  public headerCategoryList: any[];
  public productCollections: any[] = [];
  public ProductSliderConfig: any = MultiProductSlider;
  public brandSliderConfig: any = BrandSlider;
  public PurchasedItemsConfig: any = PurchasedItemsSlider;
  public offerSliderDetails: object;
  public purchaseditemsSliderDetails: object;
  public branditemsSliderDetails: object;
  public adscontainer: any;
  public collections: any;
  public sliders: any;
  public dealslist: any;
  public purchaseditems: any;
  public brands: any;
  public topCategories = [];
  public topCategoriesList = [];
  public HomeSliderConfig: any = HomeSlider;
  public topCategoriesBanners = [];
  public sortBy: string = 'Position';
  public topCategoriesLeftSideBanner: any = [];

  constructor(public productService: ProductService,
    private homeService: HomeService, private router: Router,
    public globalService: GlobalService) {
    // this.homeService.getcategories(CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_INDEX, 3,
    // CUSTOMER_PORTAL_CONSTANT.TOPCATEGORIES_BANNER_TARGET_SIZE).subscribe((result) => {
    //   let response: any = result?.data;
    //   let responseData: any = response?.slice(0, 2);
    //   this.topCategoriesLeftSideBanner = responseData;
    //   console.log('************************** =', responseData);
    // });

  }


  ngOnInit(): void {
    const isGuestUser = !(JSON.parse(localStorage.getItem('currentUser'))?.customer_id);
    
    this.homeService.getadscontainer().subscribe((adscontainer: any) => {
      this.collections = adscontainer?.data?.slice(0, 3);
      this.dealslist = adscontainer?.data?.slice(3, 6);
      for (let i = 0; i < this.collections?.length; i++) {
        this.collections[i]['containername'] = 'adscontainer';
      }
      for (let i = 0; i < this.dealslist?.length; i++) {
        this.dealslist[i]['containername'] = 'dealslist';
      }
    });
    this.homeService.getSliders().subscribe((sliders: any) => {
      const tempObject: any = sliders?.data;
      this.sliders = tempObject?.sort(({ display_order: a }, { display_order: b }) => a - b);
      if (this.sliders) {
        this.sliders[0]['containername'] = 'slider';
      }
    });
    
    if(isGuestUser) {
      this.homeService.customerStoreId.subscribe((data) => {
        if (data) {
          this.initializeCalls();
        }
      })
    } else {
      this.initializeCalls();
    }
    // setTimeout(() => , 300);

    this.offerSliderDetails = {
      title: 'common.label.thisweekoffers',
      redirectUrl: '',
      currency: this.productService.Currency,
      isOfferSlider: true
    }
    this.purchaseditemsSliderDetails = {
      title: 'common.label.recentlypurchaseditems'
    }
    this.branditemsSliderDetails = {
      title: 'common.label.brandstore'
    }
  }

  initializeCalls() {
    console.log('store id comp', CommonUtil.getStoreIdFromLocalStorageUserProfile('store_id'));
        this.homeService.getbrands(CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_INDEX,
          CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_SIZE).subscribe((brands: any) => {
            const response: any = brands?.data;
            const responseData: any = response?.records;
            this.brands = responseData;
          });
        this.homeService.getpurchaseditems(CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_INDEX, CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_SIZE).subscribe((purchaseditems: any) => {
          let response: any = purchaseditems?.data;
          let responseData: any = response?.records;
          this.purchaseditems = responseData;
        });
        this.homeService.getweekoffer(CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_INDEX, CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_SIZE).subscribe(result => {
          let response: any = result?.data;
          let responseData: any = response?.records;
          let offerList = responseData?.filter(function (offer) {
            return offer?.was_price > 0;
          }
          );
          this.products = (offerList && offerList?.length > 0) ? offerList : [];
        })

        this.homeService.getcategories().subscribe((result) => {
          if (result.data) {
            let response: any = result?.data;
            let responseData: any = response?.slice(0, 10);
            this.categories = responseData;
            this.headerCategoryList = response?.slice(0, 3) || [];
            this.headerCategoryList.push({
              category_id: "",
              category_image_url: "",
              category_name: "Deals",
              breadcrumb: "Deals",
              CustomProperties: {}
            });
            this.headerCategoryList.push({
              category_id: "",
              category_image_url: "",
              category_name: "About us",
              breadcrumb: "About us",
              CustomProperties: {}
            });
            this.headerCategoryList.push({
              category_id: "",
              category_image_url: "",
              category_name: "Store Finder",
              breadcrumb: "Store",
              CustomProperties: {}
            });
            this.topCategoriesLeftSideBanner = response?.slice(0, 2);
            this.getTopCategoryBanner(response?.slice(0, 2));
          }
        })
  }

  ngOnDestroy(): void {
  }

  // Product Tab collection
  getCollectionProducts(collection) {
    return this.products.filter((item) => {
      if (item.collection.find(i => i === collection)) {
        return item
      }
    })
  }

  public validateUser(): void {
    //console.log('USER DETAILS ==', localStorage.getItem(CUSTOMER_PORTAL_CONSTANT.USER_PROFILE));
    if (localStorage.getItem(CUSTOMER_PORTAL_CONSTANT.CURRENT_USER) !== null && localStorage.getItem(CUSTOMER_PORTAL_CONSTANT.CURRENT_USER)) {
      this.router.navigateByUrl('/pages/credits-and-coupons');
    }
    else {
      this.router.navigateByUrl('/public/login');
    }
  }

  public getTopCategoryBanner(topCategoryList: any): void {
    let categoryIds: any = '';
    let pageIndex: number = 1;
    let pageSize: number = 3;
    if (topCategoryList?.length > 0) {
      topCategoryList.forEach((element, index) => {
        categoryIds = (index == 0) ? '?entity_ids=' + element.category_id : categoryIds + '&entity_ids=' + element.category_id;
        // });
        let bannerType: string;
        bannerType = (index / 2 !== 0) ? 'DualSquare' : 'SinglePortrait';
        this.homeService.getTopCategoryBanner('?entity_ids=' + element.category_id, pageIndex, pageSize, bannerType).subscribe((result) => {  // Here ID need to pass backend
          let response: any = result?.data;
          let responseData: any = response?.records;
          // Prepare the Unique Object from the responseData array , Based on entity_id
          // const arrayUniqueByKey: any = [...new Map(responseData.map(item =>
          //   [item['entity_id'], item])).values()];
          responseData.forEach((element) => {
            this.topCategoriesBanners.push(element);
          });
        });
      });
      this.getTopCategoriesList(categoryIds, topCategoryList);
    }
  }

  getTopCategoriesList(categoryIds: any, topCategoryList: any): void {
    let categoryDetails = JSON.parse(localStorage.getItem('megaMenu')).megaMenu;
    categoryIds = categoryIds.replaceAll('entity_ids', 'category_ids');
    this.homeService.getTopCategories(categoryIds, CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_INDEX, CUSTOMER_PORTAL_CONSTANT.DEFAULT_PAGE_SIZE, this.sortBy, true).subscribe((result) => {  // Here ID need to pass backend
      let response: any = result?.data;
      this.topCategories = response;
      console.log('this.topCategories ====', this.topCategories);
      console.log('this.topCategoriesBanners ====', this.topCategoriesBanners);
      this.topCategories.forEach((topCategories, index) => {
        console.log('INDEX ==', index);
        topCategories['sub_categories'] = categoryDetails.filter((categories) => categories['category_id'] == topCategories['category_id'])[0]['sub_categories'];
        this.topCategoriesBanners.forEach(topCategoriesBanner => {
          if (topCategories.category_id === topCategoriesBanner.entity_id) {
            if (topCategories['categoryBanner']) {
              topCategories['categoryBanner'].push((topCategoriesBanner.banner_image_url) ? { 'imagePath': topCategoriesBanner.banner_image_url } : { 'imagePath': CUSTOMER_PORTAL_CONSTANT.DEFAULT_CATEGORY_BANNER_SINGLE_PORTRAIT });
            } else {
              topCategories['categoryBanner'] = (topCategoriesBanner.banner_image_url) ? [{ 'imagePath': topCategoriesBanner.banner_image_url }] : [{ 'imagePath': CUSTOMER_PORTAL_CONSTANT.DEFAULT_CATEGORY_BANNER_SINGLE_PORTRAIT }];
            }
          }
        });
        if (topCategories['categoryBanner'] === undefined) {
          if (index % 2 !== 0) {
            // DualSquare placeholder image
            topCategories['categoryBanner'] = [{ 'imagePath': CUSTOMER_PORTAL_CONSTANT.DEFAULT_CATEGORY_BANNER_DUAL_SQUARE }];
            topCategories['categoryBanner'].push({ 'imagePath': CUSTOMER_PORTAL_CONSTANT.DEFAULT_CATEGORY_BANNER_DUAL_SQUARE });
          } else {
            //Single Portrait placeholder image
            topCategories['categoryBanner'] = [{ 'imagePath': CUSTOMER_PORTAL_CONSTANT.DEFAULT_CATEGORY_BANNER_SINGLE_PORTRAIT }];
          }
        }
        // if(index % 2 !== 0) {
        //     // DualSquare placeholder image
        //     topCategories['subCategoryBackgroundImage'] = CUSTOMER_PORTAL_CONSTANT.DEFAULT_SUB_CATEGORY_BANNER_EVEN;
        //   } else {
        //     //Single Portrait placeholder image
        //     topCategories['subCategoryBackgroundImage'] = CUSTOMER_PORTAL_CONSTANT.DEFAULT_SUB_CATEGORY_BANNER_ODD;
        //   }
        // SubCategory background Image logic , we will enable , if required dynamic
        this.topCategoriesLeftSideBanner.forEach(element => {
          if (element.category_id === topCategories.category_id) {
            topCategories['subCategoryBackgroundImage'] = element.category_image_url;
          }
        });
        // SubCategory background Image logic , we will enable , if required dynamic
        topCategoryList.forEach(element => {
          if (element.category_id === topCategories.category_id) {
            topCategories['subCategoryBackgroundImage'] = element.category_image_url;
          }
        });
      });
    });
  }
  navigateBrandProductList(id: number) {
    this.router.navigate(['/shop/product-list', id]);
  }

  navigateCategoryList(category: any) {
    this.router.navigate(['/shop/category-product-list', category?.category_id]);
  }
}
